export default __webpack_public_path__ + "static/media/Ubuntu-B.4edf04ac.ttf";